module.exports = __webpack_public_path__ + "static/media/notice-2.e48b278f.jpg";